import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
const OptionNestedPickerFieldBreadcrumbs = props => {
  const crumbs = props.crumbs,
    onSelect = props.onSelect;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, crumbs.map(crumb => /*#__PURE__*/React.createElement("span", {
    key: crumb.identifier,
    className: "t-onpnb-".concat(kebabCase(crumb.title)),
    role: "button",
    tabIndex: 0,
    style: {
      cursor: 'pointer',
      display: 'inline'
    },
    onKeyDown: () => onSelect(crumb),
    onClick: () => onSelect(crumb)
  }, /*#__PURE__*/React.createElement("small", null, "".concat(crumb.title, " /"), "\xA0"))));
};
OptionNestedPickerFieldBreadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired
};
export default OptionNestedPickerFieldBreadcrumbs;